<app-alert-modal [open]="open | async"
  message="Your session is about to expire in 2 minutes. Would you like to continue the session" acceptText="Continue"
  (openChange)="onAlertChange($event)">

</app-alert-modal>